import { Component, effect, input, output, signal, untracked } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { FilterHeaderComponent } from '@vectronic/ui';
@Component({
  selector: 'table-datatable-filter-integer',
  templateUrl: './datatable-filter-integer.component.html',
  styleUrls: ['./datatable-filter-integer.component.scss'],
  imports: [MatFormFieldModule, MatInputModule, MatSelectModule, FilterHeaderComponent],
})
export class DatatableFilterIntegerComponent {
  title = input.required<string>();
  value = input<number | undefined>();
  expanded = input.required<boolean>();
  options = input<{
    prefix?: string;
    suffix?: string;
    min?: number;
    max?: number;
    units?: { label: string; factor: number }[];
  }>();
  hideToggle = input(false);

  valueChange = output<number | undefined>();
  toggled = output<void>();

  selectedFactor = signal(1);

  private updateFactorScaleOnValueChangeEffect = effect(() => {
    const value = this.value();
    const units = this.options()?.units;
    if (value === undefined || !units?.length) return;

    untracked(() => {
      const currentFactor = this.selectedFactor();
      if (value % currentFactor !== 0 || currentFactor === 1) {
        const matchingUnit = [...units].reverse().find((u) => value % u.factor === 0);
        if (matchingUnit && matchingUnit.factor !== currentFactor) {
          this.selectedFactor.set(matchingUnit.factor);
        }
      }
    });
  });

  get displayValue(): number | undefined {
    const val = this.value();
    const factor = this.selectedFactor();
    if (val === undefined) return undefined;
    return val / factor;
  }

  onInputChange(event: Event) {
    const valueStr = (event.target as HTMLInputElement).value;
    let numberValue = valueStr === '' ? undefined : Number(valueStr);

    if (numberValue !== undefined) {
      const min = this.options()?.min;
      const max = this.options()?.max;
      if (min !== undefined && numberValue < min) numberValue = min;
      if (max !== undefined && numberValue > max) numberValue = max;
    }

    if (numberValue === undefined) {
      this.valueChange.emit(undefined);
    } else {
      this.valueChange.emit(numberValue * this.selectedFactor());
    }
  }

  onUnitChange(event: MatSelectChange) {
    const newFactor = event.value;
    const currentDisplayValue = this.displayValue;

    this.selectedFactor.set(newFactor);

    if (currentDisplayValue !== undefined) {
      this.valueChange.emit(currentDisplayValue * newFactor);
    }
  }
}
